<template>
  <el-dialog
    class="rc-dialog"
    title="共享管理"
    :visible.sync="showModal.flag"
    v-if="showModal.flag"
    width="50%"
    top="30vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
    @close="close"
  >
    <el-form inline size="small">
      <el-form-item>
        <butn
          v-permission="'news:share'"
          title="共享"
          :disabled="!shareEnable"
          @click="share"
        ></butn>
        <butn
          v-permission="'news:share'"
          title="取消共享"
          :disabled="!cancelEnable"
          @click="cancleShare"
        ></butn>
        <butn
          v-permission="'news:recover'"
          title="恢复"
          :disabled="!recoveryEnable"
          @click="recoveryShare"
        ></butn>
        <el-checkbox
          v-permission="'news:share:online'"
          class="m-l-14"
          v-model="needOnline"
          key="needOnline"
          :true-label="1"
          :false-label="0"
          >共享或恢复后直接上线
        </el-checkbox>
      </el-form-item>
    </el-form>
    <Table @selection-change="selectChange" :data="list" />
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Table from "./table.js";
import {
  getNewsShareList,
  saveNewsBatchShareList,
  cancelNewsShareList,
  batchRecoverNewsShareList
} from "@/api/resourceService";
import { Confirm } from "@/components/Confirm";
export default {
  components: { butn, Table },
  props: {
    showModal: {
      type: Object,
      default: function () {
        return {
          id: "",
        };
      },
    },
  },
  data() {
    return {
      list: [],
      deptName: "",
      api: getNewsShareList,
      checkArray: [],
      currentId: "",
      shareEnable: false,
      cancelEnable: false,
      recoveryEnable: false,
      needOnline: 0,
    };
  },
  created() {
    this.currentId = this.showModal.id;
    this.getData();
  },
  computed: {
    depIds() {
      return this.checkArray.map((ele) => {
        return ele.deptId;
      });
    },
    sharedToBizIds() {
      return this.checkArray.map((ele) => {
        return ele.sharedToBizId;
      });
    },
  },
  methods: {
    resetData() {
      this.deptName = "";
      this.getData();
    },
    selectChange(selections) {
      this.checkArray = selections;
      if (this.checkArray.length === 0) {
        this.shareEnable = false;
        this.cancelEnable = false;
        this.recoveryEnable = false;
      } else {
        let shareEnable = true;
        let cancelEnable = true;
        let recoveryEnable = true;
        for (const ele of this.checkArray) {
          if (ele.sharedStatus === 0) {
            // 已共享状态不能勾选共享
            shareEnable = false;

            if (ele.isDelete === "1") {
              // 已共享删除状态不能取消共享
              cancelEnable = false;
            } else if (ele.isDelete === "0") {
              // 已共享未删除状态恢复
              recoveryEnable = false;
            }
          } else {
            // 不是已同步状态都不能勾选取消共享、恢复
            cancelEnable = false;
            recoveryEnable = false;
          }
        }
        this.shareEnable = shareEnable;
        this.cancelEnable = cancelEnable;
        this.recoveryEnable = recoveryEnable;
      }
    },
    getData() {
      let params = { uuid: this.currentId };
      if (this.deptName) {
        params["deptName"] = this.deptName;
      }
      getNewsShareList(params).then((res) => {
        if (!res || res.code != 0) return;
        this.list = res.data;
      });
    },
    share() {
      saveNewsBatchShareList({
        uuids: [this.currentId],
        deptIds: this.depIds,
        needOnline: this.needOnline,
      }).then((res) => {
        if (!res || res.code != 0) return;
        this.$message({
          message: "共享成功",
          type: "success",
        });
        this.getData();
        this.$emit("reloadTable");
      });
    },
    cancleShare() {
      cancelNewsShareList({
        uuids: [this.currentId],
        deptIds: this.depIds,
        needOnline: this.needOnline,
      }).then((res) => {
        if (!res || res.code != 0) return;
        this.$message({
          message: "取消共享成功",
          type: "success",
        });
        this.getData();
        this.$emit("reloadTable");
      });
    },
    async recoveryShare() {
      const text = "确定恢复共享该配置吗?";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        batchRecoverNewsShareList({
          uuids: [this.currentId],
          deptIds: this.depIds,
          needOnline: this.needOnline,
        }).then((res) => {
          if (!res || res.code != 0) return;
          this.$message({
            message: "恢复成功",
            type: "success",
          });
          this.getData();
          this.$emit("reloadTable");
        });
        // recovery({ uuids: this.sharedToBizIds }).then((res) => {
        //   if (!res || res.code != 0) return;
        //   Message({
        //     message: "恢复成功",
        //     type: "success",
        //   });
        //   this.getData();
        //   this.$emit("reloadTable");
        // });
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    close() {
      this.shareEnable = false;
      this.cancelEnable = false;
      this.recoveryEnable = false;
      this.$emit("closeDialog");
    },
  },
};
</script>

<style lang="scss" scoped>
.rc-dialog {
  /deep/ .el-dialog__body {
    max-height: 300px;
  }
  .left {
    margin-left: 10px;
  }
  /deep/ .el-input {
    width: 50%;
  }
}
</style>
